export default "__VITE_ASSET__Dc3oLB2o__"